<template>
    <div class="health">
        <div class="my-3">
            <div class="select d-flex align-items-center justify-content-between gap-4">
                <div class="item cursor-pointer p-3 w-100 border-radius-28 text-center"
                     v-for="hc in healthConditions"
                     v-if="health_condition"
                     :class="[hc.COLOR, hc.NAME === health_condition.NAME ? 'active' : '']"
                     @click="healthType(hc)">
                    <h5>
                        {{ trans(`general.module.health.${hc.NAME}.name`) }}
                    </h5>
                    <div class="align-items-center">
                        <i :class="hc.ICON" class="daily-report-icon"></i>
                    </div>
                </div>
            </div>
        </div>
        <custom-select
            v-if="health_condition && health_condition.OPTIONS !== null"
            v-model="selectedHealthOptions"
            :items="healthConditionsDesigner"
            type="list"/>
    </div>
</template>

<script>
import CustomSelect from "../../../../theme/molecules/CustomSelect.vue";
import {HEALTH_CONDITIONS_TYPES} from "../../../../services/Defaults";
import GeneralReportForm from "../GeneralReportForm.vue";

export default {
    name: "Health",
    extends: GeneralReportForm,
    components: {CustomSelect},
    data() {
        return {
            model: {
                ...this.value,
                health_type: HEALTH_CONDITIONS_TYPES.SYMPTOMS.NAME,
                health_topic: null,
            },

            health_condition: HEALTH_CONDITIONS_TYPES.SYMPTOMS,
            selectedHealthOptions: [],
        };
    },
    watch: {
        model: {
            handler: function (value) {
                this.internalUpdate = true;
                this.$emit('input', value);
            },
            deep: true
        },
        selectedHealthOptions: function (items) {
            const selectedItems = items.map(item => item.value)
            this.model.health_topic = JSON.stringify(selectedItems);
        }
    },
    computed: {
        healthConditions() {
            return Object.values(HEALTH_CONDITIONS_TYPES)
        },
        healthConditionsDesigner() {
            return this.getSelectItems(
                Object.entries(HEALTH_CONDITIONS_TYPES.SYMPTOMS.DESIGNER),
                'general.module.health.' + this.health_condition.NAME
            )
        },
    },
    methods: {
        healthType(type) {
            this.health_condition = type;
            this.model.health_type = type.NAME;
        },
    },
};
</script>

<style scoped>
.health .item {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.health .item.active {
    border: 3px solid #503E9D;
}
</style>
